import type { LogEntry } from "./types";
import { DAY_LENGTH } from "../common/time";
export function getHabitComparator<
  T extends {
    habitId: string;
  }
>(
  logs: LogEntry<any>[] | null | undefined,
  beginingOfDayInMs: number
): (arg0: T, arg1: T) => number {
  return getHabitLogComparator(
    logs,
    beginingOfDayInMs,
    (habit: T) => habit.habitId
  );
}
export function getHabitLogComparator<T>(
  logs: LogEntry<any>[] | null | undefined,
  beginingOfDayInMs: number,
  keyFunc: (arg0: T) => string
): (arg0: T, arg1: T) => number {
  if (logs == null) {
    return () => 0;
  }

  const beginingOfYesterdayInMs = beginingOfDayInMs - DAY_LENGTH;
  const timeMap: {
    [key: string]: number;
  } = {};
  // assume that the log is in chronological order
  logs.forEach((entry) => {
    if (
      beginingOfYesterdayInMs <= entry.time &&
      entry.time < beginingOfDayInMs &&
      timeMap[entry.type] == null
    ) {
      timeMap[entry.type] = entry.time;
    }
  });
  return (first: T, second: T) => {
    return (
      (timeMap[keyFunc(first)] || beginingOfDayInMs) -
      (timeMap[keyFunc(second)] || beginingOfDayInMs)
    );
  };
}
export function getHasCompleteLogForDay(
  beginingOfDayInMs: number,
  log: LogEntry<any>[] | null | undefined,
  type: string
) {
  if (log != null) {
    return (
      log.findIndex(
        (entry: LogEntry<any>) =>
          entry.type === type &&
          beginingOfDayInMs <= entry.time &&
          entry.time < beginingOfDayInMs + DAY_LENGTH
      ) >= 0
    );
  }

  return false;
}
